// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import VueRemote from './data/socket'
import VTooltip from 'v-tooltip'
// do not use styles of this component, as they are hard to override
// see styles in components
// import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'
import keyEventBus from './plugins/keyEventBus'
import Validation from './plugins/validation';

// drag will setup 
import drag from './directives/drag'
import help from './directives/help'

Vue.use(SlimDialog)
Vue.use(Validation);
Vue.config.productionTip = false
Vue.use(keyEventBus)

const vttOptions = {
  defaultDelay: 500,
  popover: {
    defaultDelay: 500
  }
}
Vue.use(VTooltip, vttOptions)
/*
Vue.use(
    VueRemote,
    {
        secure: false,
        host: process.env.NODE_ENV === 'production' ? window.location.hostname : 'localhost',
        port: process.env.NODE_ENV === 'production' ? window.location.port : 9000,
        path: 'ws'
    }
)
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
